import { ChangeDetectorRef, Component } from '@angular/core';
import { Router } from '@angular/router';
import { IConfig } from 'libs/dc-core/models/base.models';
import { ConfigService } from 'libs/dc-core/providers/config-service';
import { GlobalWebSocketService } from 'libs/dc-core/providers/global-web-socket/global-web-socket.service';
import { SessionStorageService } from 'src/app/components/storage/session-storage.service';
import "regenerator-runtime/runtime";
import Amplify, { Auth } from 'aws-amplify';
import { UserPoolPrecis } from './shared/auto-generated-devumconsole/models/auto-generated-models';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  baseUrl: string;
  authorization: string = null;
  userProfile: any;
  isGlobalWSInitialized = false;

  constructor(private configService: ConfigService, private ref: ChangeDetectorRef, private router: Router,
    private sessionStorageService: SessionStorageService, private globalWebSocketService: GlobalWebSocketService) { }

  ngOnInit() {
    this.loadConfig();
    let profile: UserPoolPrecis = this.sessionStorageService.getUserPool();
    if (profile) {
      Amplify.configure({
        Auth: {
          region: profile?.region,
          userPoolId: profile?.userPoolId,
          userPoolWebClientId: profile?.consoleUserAppClientId
        }
      });
      this.refreshToken();
    }
  }

  async refreshToken() {
    try {
      const cognitoUser = await Auth.currentAuthenticatedUser();
      const currentSession = await Auth.currentSession();
      if (cognitoUser && currentSession) {
        cognitoUser.refreshSession(currentSession.getRefreshToken(), (err: any, session: any) => {
          this.sessionStorageService.setCognitoToken(session?.idToken?.jwtToken);
        });
      } else {
        this.logout();
      }
    } catch (e) {
      this.logout();
    }
  }

  private async loadConfig() {
    const promise = await fetch('assets/json/config.json');
    const result: IConfig = await promise.json();
    this.configService.setConfig(result);
    this.authorization = this.sessionStorageService.getCognitoToken();
    this.baseUrl = result.serverURL;
    this.initGlobalWebSocketConnection();
    this.setPath();
  }

  private setPath() {
    let path = '';
    if (!location.hash.endsWith('#/')) {
      path = location.hash.replace('#/', '');
      this.sessionStorageService.setCurrentPage(path);
    } else {
      this.sessionStorageService.setCurrentPage(path);
    }
    this.navigateOnAuthentication();
  }
  private navigateOnAuthentication() {
    let path = this.sessionStorageService.getCurrentPage();
    if (!path || path == 'login') {
      path = "";
    }
    this.router.navigateByUrl(path);
  }
  private async initGlobalWebSocketConnection() {
    this.globalWebSocketService.init();
    this.isGlobalWSInitialized = true;
  }

  async logout() {
    await Auth.signOut();
    this.sessionStorageService.clearSession();
    location.href = ''
  }
}